import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

export function parseChecklist(html) {
  const doc = new DOMParser().parseFromString(typeof html === "string" ? html : "", "text/html");
  const groups = new Map();
  doc.querySelectorAll('.plink input[type="checkbox"]').forEach(input => {
    const id = input.getAttribute("value") || "";
    if (!/^\d+$/.test(id)) return;
    const room = (input.getAttribute("data-roomname") || "Übertragene Aufgaben").replace(/\s+/g, "");
    if (!groups.has(room)) groups.set(room, []);
    if (!groups.get(room).some(item => item.id === id)) {
      const label = input.closest(".plink").cloneNode(true);
      label.querySelectorAll("input, script, style").forEach(node => node.remove());
      groups.get(room).push({ id, title: label.textContent.trim() });
    }
  });
  return [...groups].map(([room, items]) => ({ room, items }));
}

export default function TeacherChecklistForm({ type }) {
  const [groups, setGroups] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const saveLock = useRef(false);
  const teacherId = localStorage.getItem("teacher_id_student");
  const title = type === "abschluss" ? "Abschluss" : "Vorbereitung";
  const endpoint = type === "abschluss" ? "getTeacherAbsChecklistById" : "getTeacherChecklistById";
  function url(action) {
    const params = new URLSearchParams({
      login_cookie: localStorage.getItem("session_user_login_cookie") || "",
      login_user_id: localStorage.getItem("session_user_id") || "",
      login_action_type: localStorage.getItem("session_user_type") || "",
      f: action, status: "1", teacher_id: teacherId || "", location: "ZH",
    });
    return `${process.env.REACT_APP_API_BASE_URL}/?${params}`;
  }
  useEffect(() => {
    let active = true;
    setLoading(true);
    if (!/^\d+$/.test(teacherId || "")) {
      setError("Dein Lehrerkonto ist nicht zugeordnet. Bitte melde dich bei der Administration.");
      setLoading(false);
      return;
    }
    axios.post(url(endpoint)).then(response => {
      if (!active) return;
      if (typeof response.data !== "string") throw new Error("Die Checkliste konnte nicht geladen werden.");
      setGroups(parseChecklist(response.data));
      setSelected([]);
      setError("");
    }).catch(() => { if (active) setError("Die Checkliste konnte nicht geladen werden. Bitte erneut öffnen."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
    // One read per teacher/type; response changes must not trigger another request.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teacherId, endpoint]);

  function toggle(ids, checked) {
    setSelected(previous => checked ? [...new Set([...previous, ...ids])] : previous.filter(id => !ids.includes(id)));
  }
  async function submit(event) {
    event.preventDefault();
    if (saveLock.current || !selected.length || loading || error) return;
    saveLock.current = true;
    setSaving(true);
    const submitted = [...selected];
    const body = new FormData();
    body.append("point_type", type);
    body.append("teacher_id", teacherId);
    submitted.forEach(id => body.append("option_list[]", id));
    try {
      const response = await axios.post(url("addTeacherChecklistMultiple"), body);
      if (response.data?.status !== true) throw new Error(response.data?.message || "Speichern fehlgeschlagen.");
      setGroups(previous => previous.map(group => ({ ...group, items: group.items.filter(item => !submitted.includes(item.id)) })).filter(group => group.items.length));
      setSelected(previous => previous.filter(id => !submitted.includes(id)));
      toast.success("Checkliste gespeichert.");
    } catch (failure) { toast.error(failure.message || "Speichern fehlgeschlagen. Bitte den Stand vor erneutem Speichern prüfen."); }
    finally { saveLock.current = false; setSaving(false); }
  }
  return <div className={`${type}_section`}><ToastContainer /><div className="container-fluid">
    <div className="user_detail"><h2>{title}</h2></div>
    {loading ? <p role="status">Checkliste wird geladen…</p> : error ? <p role="alert">{error}</p> :
      <form onSubmit={submit}><div className="row">
        {groups.map(group => <div className={`${type}_card col-xxl-4 col-xl-6 col-lg-6 col-12`} key={group.room}>
          <div className={`${type}_card_inner`}><h3><label><input type="checkbox" disabled={saving}
            checked={group.items.every(item => selected.includes(item.id))}
            onChange={event => toggle(group.items.map(item => item.id), event.target.checked)} /> {group.room}</label></h3>
          {group.items.map(item => <div className="form-check" key={item.id}><label><input type="checkbox" disabled={saving}
            checked={selected.includes(item.id)} onChange={event => toggle([item.id], event.target.checked)} /> {item.title}</label></div>)}
          </div></div>)}
      </div>{!groups.length ? <p>Keine offenen Checklistenpunkte.</p> :
        <button className="btn btn_primary" type="submit" disabled={saving || !selected.length}>{saving ? "Wird gespeichert…" : "Speichern"}</button>}
      </form>}
  </div></div>;
}
